"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadTable = exports.UploadPane = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = __importDefault(require("react"));
const icon_button_1 = require("./icon-button");
const ProgressBar_1 = __importDefault(require("react-bootstrap/ProgressBar"));
class UploadPane extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            Expanded: false
        };
    }
    render() {
        if (!this.props.Uploads.length) {
            return null;
        }
        const onClick = () => {
            this.setState({
                Expanded: !this.state.Expanded
            });
        };
        return react_1.default.createElement("div", { className: "container border-bottom" },
            this.props.Uploads.length > 1 ? (react_1.default.createElement("span", { className: "float-right" },
                react_1.default.createElement(icon_button_1.IconButton, { icon: this.state.Expanded ? free_solid_svg_icons_1.faChevronDown : free_solid_svg_icons_1.faChevronUp, title: this.state.Expanded ? "Collapse" : "Show all", onClick: onClick }))) : null,
            react_1.default.createElement("div", { className: this.state.Expanded ? "collapse" : "collapse.show" },
                react_1.default.createElement("div", { className: "d-flex align-items-center" },
                    react_1.default.createElement("div", { className: "align-content-start p-2 text-secondary" }, "Uploading"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(UploadTable, { Uploads: this.props.Uploads.slice(0, 1) })),
                    this.props.Uploads.length > 1 ? (react_1.default.createElement("div", { className: "col-auto ml-auto" },
                        "and ",
                        this.props.Uploads.length - 1,
                        " more...")) : null)),
            react_1.default.createElement("div", { className: this.state.Expanded ? "collapse.show" : "collapse" },
                react_1.default.createElement("b", null, "Uploading"),
                react_1.default.createElement(UploadTable, { Uploads: this.props.Uploads })));
    }
}
exports.UploadPane = UploadPane;
class UploadTable extends react_1.default.Component {
    render() {
        return react_1.default.createElement("div", { className: "align-left" },
            react_1.default.createElement("table", null, this.props.Uploads.map(upload => react_1.default.createElement(UploadRow, { Upload: upload }))));
    }
}
exports.UploadTable = UploadTable;
class UploadRow extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressPercentage: props.Upload.CurrentProgress * 100
        };
        props.Upload.OnProgress(value => this.setState({ ProgressPercentage: value * 100 }));
    }
    render() {
        const cancel = () => this.props.Upload.Cancel();
        return react_1.default.createElement("tr", null,
            react_1.default.createElement("td", { className: "p-1 text-truncate", style: { maxWidth: "200px" } }, this.props.Upload.Name),
            react_1.default.createElement("td", { className: "p-1" },
                react_1.default.createElement(ProgressBar_1.default, { now: this.state.ProgressPercentage, style: { width: "150px" } })),
            react_1.default.createElement("td", { className: "p-1", style: { width: "50px", textAlign: "right" } },
                this.state.ProgressPercentage.toFixed(0),
                "%"),
            react_1.default.createElement("td", { className: "p-1" },
                react_1.default.createElement(icon_button_1.IconButton, { icon: free_solid_svg_icons_1.faTimes, title: "Cancel", onClick: cancel })));
    }
}
//# sourceMappingURL=upload-pane.js.map